import { filterData } from '../../../functions/search.functions';

export default class AmFilterPaginationService {
  constructor($q, $filter) {
    'ngInject';
    this.$q = $q;
    this.$filter = $filter;
  }
  filterByTerm(data = [], term = '', propertyKeys = []) {
    return filterData(data, term, propertyKeys);
  }

  getPaged(filter, paging = {}, data = [], propertyKeys = []) {
    return this.$q((resolve) => {
      if (filter.query) {
        data = filterData(data, filter.query, propertyKeys);
      }
      const total = data.length;
      if (filter.orderBy) {
        data = this.$filter('orderBy')(data, filter.orderBy.attr, filter.orderBy.desc);
      }
      if (filter.clientSideOrderBy) {
        data = this.$filter('orderBy')(
          data,
          filter.clientSideOrderBy.attr,
          filter.clientSideOrderBy.desc,
        );
      }
      let end = paging.startFrom + paging.pageSize;
      if (end >= total) end = undefined;
      const result = data.slice(paging.startFrom, end);
      resolve({ data: result, total });
    });
  }
}
